<template>
    <main class="app-container">
        <section class="profile" v-if="userInfo">
            <div class="profile__top">
                <h2>{{$t('profile.my_profile_title')}}</h2>
                <router-link to="/my-profile/edit" class="button-outline"> {{$t('profile.my_profile_edit_title')}} </router-link>
            </div>
            <div class="profile__inner loader-block-parent">
                <div v-show="isLoading" class="loader-block">
                    <div>
                        <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
                    </div>
                </div>
                <div class="profile__left">
                    <h3>{{$t('profile.my_profile_title')}}</h3>
                    <img v-show="userStore.userInfo?.imagePath" class="profile__left-photo" id="profile_photo" :src="userStore.userInfo?.imagePath"/>
                    <img v-show="!userStore.userInfo?.imagePath" class="profile__left-photo" id="profile_photo_blank" src="@/assets/images/blank_person.jpg" />

                    <p class="profile__left-name">{{userStore.userInfo.firstName + ' ' + userStore.userInfo.lastName}}</p>
                    <p class="profile__left-position">{{$t('profile.role.' + userStore.user.role.toLowerCase())}}</p>
                    <a :href="'tel:'+userStore.userInfo?.phone" class="profile__left-phone">{{userStore.userInfo?.phone}}</a>
                    <div class="specs">
                        <p class="specs__title">{{$t('profile.specialization_title')}}</p>
                        <div class="specs__list">
                            <div class="specs__item" v-for="specialization in userInfo?.userSpecializations" :key="specialization.id">
                                {{specialization.name}}
                            </div>
                        </div>
                    </div>
                    <div class="description">
                        <p class="description__title">{{$t('profile.description_title')}}</p>
                        <p class="description__text">
                            {{userInfo.description}}
                        </p>
                    </div>
                    <div class="line"></div>
                    <div class="socials">
                        <div class="social">
                            <a :href="userStore.userInfo.facebookUrl">{{userStore.userInfo.facebookUrl}}</a>
                        </div>
                        <div class="social">
                            <a :href="userStore.userInfo.facebookUrl">{{userStore.userInfo.instagramUrl}}</a>
                        </div>
                    </div>
                </div>
                <div class="profile__right">
                    <div class="box">
                        <h3>{{$t('profile.basic_company_data_title')}}</h3>
                        <p class="box__fullname">{{userStore.userInfo.company?.name}}</p>
                        <p class="box__company-info">
                            <template v-if="userStore.userInfo.company?.address">{{userStore.userInfo.company?.address}}<br /></template>
                            <template v-if="userStore.userInfo.company?.zipCode || userStore.userInfo.company?.city">{{userStore.userInfo.company?.zipCode}} {{userStore.userInfo.company?.city}}<br /></template>
                            <template v-if="userStore.userInfo.company?.province">{{userStore.userInfo.company?.province}}<br /></template>
                            <br />
                            <template v-if="userStore.userInfo.company?.nip">NIP: {{userStore.userInfo.company?.nip}}<br /></template>
                            <template v-if="userStore.userInfo.company?.regon">REGON: {{userStore.userInfo.company?.regon}}</template>
                        </p>
                    </div>
                </div>
            </div>
        </section>
    </main>
</template>

<script>
import Menu from "@/components/Menu";
import UserLayout from "@/layouts/UserLayout";
import {useAuthStore} from "@/stores/auth.store";
import UserService from "@/services/user.service";
import {inject, watch} from "vue";
import {storeToRefs} from "pinia";

export default {
    name: "MyProfileView",
    components: {
        UserLayout,
        Menu
    },
    setup() {
        const userStore = useAuthStore();
        const {isLoading,userInfo} = storeToRefs(userStore);
        const alert = inject('alert');

        return  {
            isLoading,
            userStore,
            userInfo
        }
    }
}
</script>

<style scoped lang="scss">
.profile{
    &__left{
        &-photo {
            object-fit: cover;
            display: flex;
        }
    }
}
</style>